import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-add-document',
  templateUrl: './add-document.component.html',
  styleUrl: './add-document.component.scss'
})
export class AddDocumentComponent implements OnInit {
ngOnInit(): void {}
@Output() ImageFileURL: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.appBaseUrl = window.location.origin +'/'+ window.location.pathname.split('/')[1];
  }
  file: File = null;
  files: any = [];
  blobData: any;
  fileID: any = '';
  DocumentURL: any = '';
  appBaseUrl: any;
  URL: any = '';
  allowedFileTypes: any[] = [
    { ext: 'pdf', label: 'PDF doc' },
    { ext: 'doc', label: 'word File' },
    { ext: 'docx', label: 'word File' },
    { ext: 'xlsx', label: 'Excel File' },
    { ext: 'xls', label: 'Excel File' },
  ];
  maxFileSize: any = '10 MB';
  closeAddDocumentPopup() {
    this.bsModalRef.hide();
  }

  goBack() {
    this.bsModalRef.hide();
  }

  handleCancel(event) {
    if (event) {
      this.bsModalRef.hide();
    }
  }

  handleFileUpload(newFile: any) {
    if(newFile === null || newFile === undefined)  {
      return;
    }
    // Handle file upload logic here
    if(newFile instanceof File) {
      this.file = newFile;
      console.log('File uploaded:', this.file);
      let files = [];
    }
  }

  filesDropped(files: any): void {
    this.files = files;
  }

  uploadFile() {

  }
  uploadDocument(fileID: any) {

  }
}
